import { Locale } from 'shared/i18n/interface'
import { useQuery } from '@tanstack/react-query'
import config from 'config'
import { PRICING_STALE_TIME, PRICING_CACHE_TIME } from '~/app/constants'
import { queryDefaultQuantities, QUERY_KEY } from '~/app/features/Gallery/queries/queryDefaultQuantities'
import { getDefaultQuantity } from '~/app/utils/getDefaultQuantity'
import type { GalleryModelsUrl } from 'shared/types/gallery/models'
import type { MTT } from 'shared/types/vp/mtt'

export interface UseQuantitiesInput {
  productKey?: string
  productVersion?: number
  locale: Locale
  quantity: GalleryModelsUrl.ValidParsedQsValue<number>
}

export const queryKey = ({ productKey, productVersion, locale }: UseQuantitiesInput): MTT.Queries.MsxService.DefaultQuantitiesQueryKey => [
  QUERY_KEY,
  {
    productKey,
    version: productVersion,
    tenant: config.tenant,
    locales: [locale],
  },
]

export const useQuantities = (params: UseQuantitiesInput): MTT.Models.MsxService.QuantitiesDataResult => {
  const { productKey, productVersion, locale, quantity } = params

  // Fetch the Default Quantities (already prefetched server-side)
  const { data: quantitiesData } = useQuery({
    queryKey: queryKey(params),
    queryFn: queryDefaultQuantities,
    enabled: !!productKey && !!productVersion,
    staleTime: PRICING_STALE_TIME,
    gcTime: PRICING_CACHE_TIME,
  })

  return {
    quantitiesData,
    productQuantity: getDefaultQuantity({ locale, quantity, quantitiesData }),
  }
}
